import { ShoppingCart } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useCart } from "@/contexts/CartContext";
import { MobileTooltip } from "@/components/ui/mobile-tooltip";

export function CartButton() {
  const { totalItems, setIsCartOpen } = useCart();

  return (
    <MobileTooltip content="Kosarad megtekintése">
      <Button
        id="btn-cart"
        variant="outline"
        size="default"
        onClick={() => setIsCartOpen(true)}
        className="tour-cart-btn bg-cart hover:bg-cart/90 border-cart text-cart-foreground flex items-center gap-2 relative"
      >
        <ShoppingCart className="h-4 w-4" />
        <span className="hidden sm:inline">Kosarad</span>
        {totalItems > 0 && (
          <span className="absolute -top-2 -right-2 bg-cart/80 text-cart-foreground text-xs rounded-full h-5 w-5 flex items-center justify-center font-bold">
            {totalItems}
          </span>
        )}
      </Button>
    </MobileTooltip>
  );
}
